/**
 * Timeline scroll container.
 *
 * Sets max-height to show exactly 4.5 items, calculated from
 * actual rendered item heights. Adds/removes .is-scrolled-end
 * class to toggle the bottom fade gradient.
 */

const VISIBLE_ITEMS = 4.5;

function initTimeline(container) {
  const items = container.querySelectorAll(':scope > .timeline-item');
  if (items.length <= Math.ceil(VISIBLE_ITEMS)) return;

  // Calculate height of first 4.5 items
  let height = 0;
  for (let i = 0; i < Math.floor(VISIBLE_ITEMS); i++) {
    height += items[i].offsetHeight;
  }
  // Add half of the next item
  const halfItem = items[Math.floor(VISIBLE_ITEMS)];
  if (halfItem) {
    height += halfItem.offsetHeight * (VISIBLE_ITEMS % 1);
  }

  container.style.maxHeight = `${height}px`;

  // Toggle fade class on scroll
  const onScroll = () => {
    const atEnd =
      container.scrollTop + container.clientHeight >= container.scrollHeight - 4;
    container.classList.toggle('is-scrolled-end', atEnd);
  };

  container.addEventListener('scroll', onScroll, { passive: true });
  onScroll();
}

document.querySelectorAll('.timeline').forEach(initTimeline);
